import React, { Component } from "react";
import styled from "styled-components";

import NavBar from "./homePage/navBar";
import PageHeader from "./homePage/pageHeader";
import PageTitle from "./homePage/pageTitle";
import AuditBlock from "./homePage/common/auditBlock";
import EnrollmentSub from "./homePage/common/enrollmentSub";
import PageFooter from "./homePage/pageFooter";
import HeaderImage from "./homePage/headerImage";

import LawRegulation from "./homePage/lawRegulation";
import NewsInformation from "./homePage/newsInformation";

const Div = styled.div`
  min-width: 130rem;
`;

class HomePage extends Component {
  render() {
    const { enrollmentSubs, auditSubs } = this.props;

    return (
      <Div>
        <PageHeader />
        <PageTitle history={this.props.history} />
        <NavBar history={this.props.history} />
        <HeaderImage />
        {enrollmentSubs.map((sub, index) => (
          <EnrollmentSub
            key={`enrollmentSub-${index}`}
            title={sub.title}
            subjects={sub.subjects}
            index={index}
            history={this.props.history}
          />
        ))}
        {auditSubs.map((data, index) => (
          <AuditBlock
            key={`auditBlock-${index}`}
            title={data.title}
            subjects={data.subjects}
            history={this.props.history}
          />
        ))}
        <LawRegulation />
        <NewsInformation />
        <PageFooter />
      </Div>
    );
  }
}

export default HomePage;
